import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { tracking } from '../util/tracking';
import { captureSupabaseError } from '../lib/sentry';

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // ✅ Get session from Supabase (set by magic link redirect)
        const { data, error } = await supabase.auth.getSession();

        if (error || !data.session) {
          console.error('No session found:', error);
          navigate('/login');
          return;
        }

        const userId = data.session.user.id;

        // Optional: determine flow from URL params
        // const params = new URLSearchParams(window.location.search);
        // const type = params.get('flowType');

        const { error: updateError } = await supabase
          .from('user_organisations')
          .update({ status: 'active' })
          .eq('profile_id', userId)
          .eq('status', 'pending');

        if (updateError) {
          console.error('Error updating organisation status:', updateError);
          alert(
            'There was an issue activating your account. Please contact support.'
          );
        }

        await tracking.log('INTERNAL', 'LOG', {
          message: `Auth callback completed`,
        });

        // Route to app
        navigate('/dashboard');
      } catch (err) {
        await tracking.log('ERROR', 'AuthCallback', {
          message: `Auth callback failed: ${
            err instanceof Error ? err.message : String(err)
          }`,
        });
        captureSupabaseError(err, { op: 'auth.callback' });
        console.error('Unexpected auth callback error:', err);
        navigate('/login');
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <p>Completing authentication…</p>
    </div>
  );
}
